<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="form-group"
  [ngClass]="{
    half: ishalf,
    mfd: isMfd,
    'view-password': viewPassword,
    'mb-0': isMfd && isFileName && !helpBlock,
  }">
  @if (label) {
    <label
      for="label"
      [ngClass]="{ 'col-sm-4': ishalf }"
      [xdaTranslate]="label"></label>
  }

  <input
    #input
    ngModel
    keep-placeholder
    [type]="type"
    [id]="id"
    [attr.name]="name"
    [attr.minlength]="minlength"
    [attr.maxlength]="maxlength"
    [min]="minValue"
    [max]="maxValue"
    [placeholder]="placeholder"
    [pattern]="pattern"
    [disabled]="disabled"
    [readonly]="readonly"
    (input)="onInput($event)"
    (blur)="onTouched()"
    (focus)="onFocus()"
    (focusout)="onBlur()"
    (keypress)="onKeyPress($event)"
    [ngClass]="{
      'is-invalid': isErrorState() || onSubmitError,
      'col-sm-8': ishalf,
      'file-name': isFileName,
      'file-name-mfd': isMfd,
      'mfd-input': isMfd,
    }"
    class="form-control" />

  @if ((isMfd || viewPassword) && (type === 'password' || showPassword)) {
    <i
      [ngClass]="showPassword ? 'xgl-view' : 'xgl-view_disabled'"
      (click)="togglePassword()"></i>
  }

  @if (isMfd && isFileName) {
    <i class="xgl-paperclip"></i>
  }

  @if ((isErrorState() || onSubmitError) && hasAnyError()) {
    <div
      class="invalid-feedback"
      [ngClass]="{ 'offset-md-4 col-sm-8': ishalf }">
      @if (ngControl.control?.errors?.['required']) {
        <div [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></div>
      }
      @if (ngControl.control?.errors?.['minlength'] && minlengtherror) {
        <div [xdaTranslate]="minlengtherror"></div>
      }
      @if (ngControl.control?.errors?.['maxlength']) {
        <div>
          <span xdaTranslate>SDE_MAX_LENGTH1</span>&nbsp;<span
            [xdaTranslate]="maxlength.toString()"></span>
        </div>
      }
      @if (ngControl.control?.errors?.['pattern'] && patternerror) {
        <div [xdaTranslate]="patternerror"></div>
      }
      @if (ngControl.control?.errors?.['email']) {
        <div [xdaTranslate]="'SDE_EMAIL_NOT_VALID'"></div>
      }
      @if (ngControl.control?.errors?.['match']) {
        <div [xdaTranslate]="matcherror"></div>
      }
      @if (ngControl.control?.errors?.['customerror']) {
        <div [xdaTranslate]="error"></div>
      }
    </div>
  }

  @if (noValidateError) {
    <div
      class="novalidate invalid-feedback"
      [ngClass]="{ 'offset-md-4 col-sm-8': ishalf }">
      <div [xdaTranslate]="noValidateError"></div>
    </div>
  }
</div>

@if (helpBlock) {
  <div
    [ngClass]="{
      'row offset-md-4 help-block col-sm-8': !isMfd && ishalf,
      'text-x-small': isMfd,
      'text-small file-help': isMfd && isFileName,
      'file-help-web': isFileName && !isMfd && !ishalf,
    }"
    [xdaTranslate]="helpBlock"></div>
}
